import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, MessageCircle, Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0d1829] border-t border-white/10 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 text-center md:text-left">
          {/* Company Info */}
          <div className="flex flex-col items-center md:items-start">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/images/deep-control-logo.png"
                alt="Deep Control"
                className="w-10 h-10 object-contain"
                data-testid="footer-logo"
              />
              <div>
                <div className="font-bold text-lg tracking-tight leading-none">DEEP CONTROL</div>
                <div className="text-[8px] text-[#FF8C00] tracking-[2px] font-semibold">HVAC SPECIALISTS</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
              Professional air conditioning and HVAC services across London. Installations, repairs, and maintenance you can trust.
            </p>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#FF8C00] transition-colors">
                <Facebook size={16} />
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#FF8C00] transition-colors">
                <Instagram size={16} />
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#FF8C00] transition-colors">
                <Linkedin size={16} />
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#FF8C00] transition-colors">
                <MessageCircle size={16} />
              </a>
            </div>
          </div>

          {/* Our Services */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="font-bold text-lg mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/installation" className="hover:text-[#FF8C00] transition-colors">Air Conditioning Installation</Link></li>
              <li><Link to="/repair" className="hover:text-[#FF8C00] transition-colors">Repairs & Breakdowns</Link></li>
              <li><Link to="/service" className="hover:text-[#FF8C00] transition-colors">Servicing & Maintenance</Link></li>
              <li><Link to="/commercial" className="hover:text-[#FF8C00] transition-colors">Commercial HVAC</Link></li>
              <li><Link to="/service" className="hover:text-[#FF8C00] transition-colors">Refrigerant Regassing</Link></li>
              <li><Link to="/commercial" className="hover:text-[#FF8C00] transition-colors">Mechanical & Electrical Works</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/about" className="hover:text-[#FF8C00] transition-colors">About Us</Link></li>
              <li><Link to="/areas" className="hover:text-[#FF8C00] transition-colors">Areas We Cover</Link></li>
              <li><Link to="/commercial" className="hover:text-[#FF8C00] transition-colors">Commercial</Link></li>
              <li><Link to="/contact" className="hover:text-[#FF8C00] transition-colors">Contact Us</Link></li>
              <li><a href="#" className="hover:text-[#FF8C00] transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-[#FF8C00] transition-colors">Terms & Conditions</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="font-bold text-lg mb-4">Contact Info</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-start gap-2">
                <Phone size={16} className="text-[#FF8C00] mt-0.5 flex-shrink-0" />
                <div>
                  <a href="tel:+442080599941" className="font-semibold text-white hover:text-[#FF8C00] transition-colors" data-testid="footer-office-link">
                    020 8059 9941
                  </a>
                  <div className="text-xs">Office &middot; 24/7 Emergency Support</div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={16} className="text-[#FF8C00] mt-0.5 flex-shrink-0" />
                <div>
                  <div className="font-semibold text-white">info@deepcontrol.co.uk</div>
                  <div className="text-xs">Get a quick response</div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={16} className="text-red-500 mt-0.5 flex-shrink-0" />
                <div>
                  <div className="font-semibold text-white">Emergency Call Out</div>
                  <a href="tel:+447990547352" className="text-xs text-[#FF8C00] hover:text-white transition-colors font-semibold" data-testid="footer-emergency-mobile-link">
                    07990 547 352
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-center items-center gap-4 text-sm text-gray-500">
          <p>© 2026 Deep Control. All rights reserved.</p>
          <span className="hidden md:inline">|</span>
          <p>F-Gas Compliant | Certified Engineers</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
